import React from 'react';
import styled from 'styled-components';
import {PageData} from '@epic-mw/types';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {HomeHeader, HomeHeaderProps} from './components/Header';
import {HomeSection, HomeSectionProps} from './components/Section';
import {useLoading, useNotFound} from '../../utils/loadingUtils';
import Error404 from '../error/Error404';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import {Subnav} from 'epic-ue-ui';
import {SubnavItemProps} from 'epic-ue-ui/src/components/elements/subnav/SubnavItem';
import {useStore} from '../../stores';

const Styled = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background-color: #121212;
    padding: 0 15px 32px;
    box-sizing: border-box;

    ${p => p.theme.breakpoints.up('sm')} {
        padding: 32px 40px 32px 40px;
    }
`;

const HomePage = styled.div`
    a.subnav-item {
        &:hover {
            text-decoration: none;
        }
    }
    .top-btn.arrow-only {
        background-color: #262626 !important;
        .underline {
            padding-left: 10px;
        }
    }
`;

interface HomePageData extends PageData {
    header: HomeHeaderProps;
    content: {
        sections: HomeSectionProps[];
    };
}

interface HomeContainerProps {
    pageData: HomePageData;
}

const HomeContainer: React.FC<HomeContainerProps> = ({pageData}) => {
    const isLoading = useLoading(pageData);
    const notFound = useNotFound(pageData);
    const [store] = useStore();
    const epicGamesFooter = store.epicGamesFooter || {};
    const backToTop = epicGamesFooter?.messages?.backToTop || 'Back to top';

    if (isLoading) {
        return <LoadIndicator fill />;
    }

    if (notFound) {
        return <Error404 />;
    }

    const {header, content} = pageData;

    const subNavItems: SubnavItemProps[] = [];
    content?.sections.forEach((section, i) => {
        if (section.title) {
            subNavItems.push({
                index: i,
                title: section.title,
                anchorId: section.title.toLowerCase()
            });
        }
    });

    return (
        <HomePage>
            {getHelmetForMetaTags(pageData)}
            <HomeHeader {...header} />
            <Subnav items={subNavItems} backToTopBtnLabel={backToTop} downloadBtnLabel="" />

            <Styled>
                {content?.sections.map((section, i) => (
                    <HomeSection key={`${section.title}_${i}`} {...section} />
                ))}
            </Styled>
        </HomePage>
    );
};

export default HomeContainer;
